import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { sendBulkMailApi } from '../../../apifile/ApiFiles';
import { toast, ToastContainer } from 'react-toastify';
import { Loaders } from '../../../../pages/Loaders';

function BulkModel(props) {
    const [loaders, setloaders] = useState(false)
    const [activeTab, setActiveTab] = useState('email');
    const [subject, setSubject] = useState('');
    const [content, setContent] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [whatsappMessage, setWhatsappMessage] = useState('');
    const [smsMessage, setSmsMessage] = useState('');


    const handleEditorChange = (value, type) => {
        if (type === 'email') {
            setEmailMessage(value);
        } else if (type === 'whatsapp') {
            setWhatsappMessage(value);
        } else if (type === 'message') {
            setSmsMessage(value);
        }
        console.log(`${type} message:`, value);
        setContent(value)
    };

    const notify = (updateMassage) => toast(updateMassage);
    const handleSubmit = async (event) => {
        setloaders(true)
        const clone = { recipients: props?.selectedIds, subject: subject, htmlContent: content }
        // console.log(clone);
        try {
            const res = await sendBulkMailApi(clone)
            // console.log(res?.data?.error);
            if (res?.data?.error == false) {
                setloaders(false)
                notify(res?.data?.message)
                setTimeout(() => {
                    props?.onHide()
                }, 1000)
            } else {
                setloaders(false)
                alert(res?.data?.message)
            }
            // notify(res?.data?.message)


        } catch (error) {

        }

        // if (activeTab === 'email') {
        //     console.log("Email Message: ", emailMessage);
        // }
        // else if (activeTab === 'whatsapp') {
        //     console.log("WhatsApp Message: ", whatsappMessage);
        // } else if (activeTab === 'message') {
        //     console.log("SMS Message: ", smsMessage);
        // }
    };

    const PopupHide = () => {
        setSubject('')
        // setContent('')  
        props?.onHide()
    }

    return (
        <>
            {loaders && <Loaders />}
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Bulk Email
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container mt-4">
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="email" title="Email">
                                {/* <h3>Email Section</h3> */}
                                <form >
                                    <div className="mb-3">
                                        <label htmlFor="subject" className="form-label">
                                            Subject <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Subject"
                                            value={subject}
                                            onChange={(e) => setSubject(e.target.value)}
                                        />

                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="emailMessage" className="form-label">
                                            Message <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <ReactQuill
                                            theme="snow"
                                            value={emailMessage}
                                            onChange={(value) => handleEditorChange(value, 'email')}
                                            placeholder="Enter email message"
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <button type="button" className="btn btn-primary text-center" onClick={handleSubmit}>Send Email</button>
                                    </div>
                                </form>
                            </Tab>

                            {/* <Tab eventKey="whatsapp" title="WhatsApp">
                            <h3>WhatsApp Section</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="whatsappMessage" className="form-label">
                                        Message
                                    </label>
                                    <ReactQuill 
                                        theme="snow" 
                                        value={whatsappMessage} 
                                        onChange={setWhatsappMessage} 
                                        placeholder="Enter WhatsApp message" 
                                    />
                                </div>
                                <button type="submit" className="btn btn-success">Send WhatsApp Message</button>
                            </form>
                        </Tab>

                        <Tab eventKey="message" title="Message">
                            <h3>Message Section</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="smsMessage" className="form-label">
                                        Message
                                    </label>
                                    <ReactQuill 
                                        theme="snow" 
                                        value={smsMessage} 
                                        onChange={setSmsMessage} 
                                        placeholder="Enter SMS message" 
                                    />
                                </div>
                                <button type="submit" className="btn btn-info">Send SMS</button>
                            </form>
                        </Tab> */}
                        </Tabs>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={PopupHide}>Close</Button>
                </Modal.Footer>
                <ToastContainer />
            </Modal>
        </>
    );
}

export default BulkModel;
